export default __webpack_public_path__ + "static/media/Mercenary's Helm of the Elder Bond.88a6e50c.jpg";